<template>
  <div>
    <p>
      Klicka här så bygger du ett dubbelställ, alltså 2 enkelställ som monteras ihop med 150 mm distanser. Du får dubbelt så många pallplatser, dubbelstället kan lastas från 2 håll.
    </p>
  </div>
</template>
<script>


import DoubleRackInfo from "@/components/infotext/DoubleRackInfo.vue";

export default {
  components: {
    DoubleRackInfo
  }
}

</script>